import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ResultData } from 'src/app/_models/ResultData';
import { FactService } from 'src/app/_services/fact.service';

@Component({
  selector: 'app-transfer-to-hoax',
  templateUrl: './transfer-to-hoax.component.html',
  styleUrls: ['./transfer-to-hoax.component.css']
})
export class TransferToHoaxComponent implements OnInit {
 myForm:FormGroup
 hoax:any=undefined
 loading=false
 isSaving=false
  constructor(private factService:FactService, private activatedRoute: ActivatedRoute, private router:Router) { }

  ngOnInit(): void {
    this.initMainFormFresh()
    this.loading=true
    this.activatedRoute.params.subscribe(
      params=>{
        this.factService.getFactBookItem(params['server_fact_id']).subscribe({
          next:(data:ResultData)=>{
            this.hoax=data.rs.data
            this.loading=false
          }
        })
      })
}

onSubmit() {
  this.isSaving=true
  if (this.myForm.invalid) {
    this.isSaving=false
    return;
  }

  const factId = this.myForm.value.factId;
  this.factService.transferToHoax(factId, this.hoax['id']).subscribe({
    next: (response) => {
      this.router.navigate(['/admin/fact/show',factId]);
      this.isSaving=false
    },
    error: (err) => {
      console.error(`Error transferring fact with ID ${factId} to hoax`, err);
      this.isSaving=false
    }
  });
}
initMainFormFresh(){
  this.myForm=new FormGroup({
    factId: new FormControl("")
  });
}
get f() {
  return this.myForm.controls
}
}
